import React from "react";
import "./DeleteButton.css";

type props = {
  onPress: () => void;
};

export const DeleteButton: React.FC<props> = ({ onPress }) => {
  return (
    <div onClick={onPress} className="delete-btn-container">
      <span className="delete-btn-text">Delete</span>
    </div>
  );
};
